import React, { Fragment, useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";

import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect
} from "react-table";
import { useTranslation, initReactI18next } from "react-i18next";
import { Table, Col, Button, Row, Input } from "reactstrap";
import { DefaultColumnFilter } from "./filters";
import { isEmpty } from "lodash";

import Loader from "./Loader";
import Pagination from "./Pagination";
import EmptyState from "./EmptyState";
import DeleteModal from "./DeleteModal";

const generateSortingIndicator = (column) => {
  return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
};

function TableStatus({
  isSuccess,
  isDataEmpty,
  tableClass,
  theadClass,
  trClass,
  thClass,
  getTableProps,
  getTableBodyProps,
  headerGroups,
  page,
  prepareRow,
  error
}) {

  const { t } = useTranslation();

  if(isDataEmpty){
    return <EmptyState
      title={t("No records found")}
      description={t("Change the filters for better results")}
    />
  } else if(isSuccess){
    return <Table hover {...getTableProps()} className={tableClass}>
      <thead className={theadClass}>
        {headerGroups.map((headerGroup) => (
          <tr className={trClass} key={headerGroup.id}  {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th key={column.id} className={thClass} {...column.getSortByToggleProps()}>
                {column.render("Header")}
                {generateSortingIndicator(column)}
                {/* <Filter column={column} /> */}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {page.map((row) => {
          prepareRow(row);
          return (
            <Fragment key={row.getRowProps().key}>
              <tr className={trClass}>
                {row.cells.map((cell, key) => {
                  return (
                    <td key={key} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            </Fragment>
          );
        })}
      </tbody>
    </Table>
  }
}

const OrdersTableBase = ({
  columns,
  data,
  isLoading,
  isSuccess,
  error,
  manualPagination,
  customPageSize,
  tableClass,
  theadClass,
  trClass,
  thClass,
  divClass,
}) => {

  const { t } = useTranslation();
  
  const [modal, setModal] = useState(false);
  const [order, setOrder] = useState([]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);


  const deleteMultiple = () => {
    const checkall = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element) => {
      //dispatch(onDeleteOrder(element.value));
      setTimeout(() => { toast.clearWaitingQueue(); }, 3000);
    });
    checkall.checked = false;
    setIsMultiDeleteButton(false);
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".orderCheckBox:checked");
    ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");

    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = (H % 12) || 12;
    h = (h <= 9) ? h = ("0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);

  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
      setDate(defaultdate());
    }
  }, [modal]);

  const handleOrderClick = useCallback((arg) => {
    const order = arg;
    setOrder({
      _id: order._id,
      orderId: order.orderId,
      customer: order.customer,
      product: order.product,
      orderDate: order.orderDate,
      ordertime: order.ordertime,
      amount: order.amount,
      payment: order.payment,
      status: order.status
    });

    setIsEdit(true);
    toggle();
  }, [toggle]);

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".orderCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  const onClickDelete = (order) => {
    setOrder(order);
    setDeleteModal(true);
  };

  const handleDeleteOrder = () => {
    if (order) {
      //dispatch(onDeleteOrder(order._id));
      setDeleteModal(false);
    }
  };
  
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,

    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,

    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      manualPagination: manualPagination,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0, pageSize: customPageSize, selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  return (
    <Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      {/*<Modal
        className="zoomIn"
        id="addSeller"
        size="lg"
        isOpen={modal}
        toggle={toggle}
        centered
      >
        <ModalHeader toggle={toggle}>Add Order</ModalHeader>
        <ModalBody>
          <Form className="tablelist-form" onSubmit={validation.handleSubmit}>
            <Row>
              <div className="mb-3">
                <h5 className="fs-14">Order information</h5>
              </div>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="reference" className="form-label" >
                    Reference Id
                  </Label>
                  <Input
                    name="reference"
                    className="form-control"
                    id="reference"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.reference || ""}
                    invalid={
                      errors && errors.reference ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.reference ? (<div>{errors.reference}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="campaign_reference" className="form-label" >
                    Campaign Reference
                  </Label>
                  <Input
                    name="campaign_reference"
                    className="form-control"
                    id="campaign_reference"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.campaign_reference || ""}
                    invalid={
                      errors && errors.campaign_reference ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.campaign_reference ? (<div>{errors.campaign_reference}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="billing_date" className="form-label" >
                    Billing date
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="billing_date"
                    placeholder="Billing date"
                    options={{
                      altInput: true,
                      altFormat: "F j, Y",
                      mode: "single",
                      dateFormat: "d.m.y",
                    }}
                    invalid={
                      errors && errors.billing_date ? true : false
                    }
                    onChange={validation.handleChange}
                  />
                  <FormFeedback type="invalid">{errors && errors.billing_date ? (<div>{errors.billing_date}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="afp_name" className="form-label" >
                    AFP Name
                  </Label>
                  <Input
                    name="afp_name"
                    className="form-control"
                    id="afp_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.afp_name || ""}
                    invalid={
                      errors && errors.afp_name ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.afp_name ? (<div >{errors.afp_name}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3">
                  <Label htmlFor="box_quantity" className="form-label" >
                    Box Quantity
                  </Label>
                  <Input
                    name="box_quantity"
                    className="form-control"
                    id="box_quantity"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.box_quantity || ""}
                    invalid={
                      errors && errors.box_quantity ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.box_quantity ? (<div>{errors.box_quantity}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3">
                  <Label htmlFor="quantity" className="form-label" >
                    Quantity
                  </Label>
                  <Input
                    name="quantity"
                    className="form-control"
                    id="quantity"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.quantity || ""}
                    invalid={
                      errors && errors.quantity ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.quantity ? (<div>{errors.quantity}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3">
                  <Label htmlFor="zone" className="form-label" >
                    Zone
                  </Label>
                  <Input
                    name="zone"
                    className="form-control"
                    id="zone"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.zone || ""}
                    invalid={
                      errors && errors.zone ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.zone ? (<div>{errors.zone}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3">
                  <Label htmlFor="territory" className="form-label" >
                    Territory
                  </Label>
                  <Input
                    name="territory"
                    className="form-control"
                    id="territory"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.territory || ""}
                    invalid={
                      errors && errors.territory ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.territory ? (<div>{errors.territory}</div>) : null}</FormFeedback>
                </div>
              </Col>

              <div className="mb-3">
                <h5 className="fs-14">Customer information</h5>
              </div>
              
              <Col lg={8}>
                <div className="mb-3">
                  <Label htmlFor="name" className="form-label" >
                    Name
                  </Label>
                  <Input
                    name="name"
                    className="form-control"
                    id="name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      errors && errors.territory ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.territory ? (<div>{errors.territory}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3">
                  <Label htmlFor="customer_reference" className="form-label" >
                    Customer Reference
                  </Label>
                  <Input
                    name="customer_reference"
                    className="form-control"
                    id="customer_reference"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.customer_reference || ""}
                    invalid={
                      errors && errors.customer_reference ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.customer_reference ? (<div>{errors.customer_reference}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={12}>
                <div className="mb-3">
                  <Label htmlFor="address" className="form-label" >
                    Address
                  </Label>
                  <Input
                    name="address"
                    className="form-control"
                    id="address"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.address || ""}
                    invalid={
                      errors && errors.address ? true : false
                    }
                  ></Input>
                  <FormFeedback type="invalid">{errors && errors.address ? (<div>{errors.address}</div>) : null}</FormFeedback>
                </div>
              </Col>
              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end">
                  <button
                    className="btn btn-link link-success text-decoration-none fw-medium"
                    data-bs-dismiss="modal"
                  >
                    <i className="ri-close-line me-1 align-middle"></i>{" "}
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    <i className="ri-save-3-line align-bottom me-1"></i>{" "}
                    Save
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>*/}
      {isLoading && <Loader/>}
      {!isLoading && (
        <div className={divClass}>
          <TableStatus
            isSuccess={isSuccess}
            isDataEmpty={!data || isEmpty(data)}
            tableClass={tableClass}
            theadClass={theadClass}
            trClass={trClass}
            thClass={thClass}
            getTableProps={getTableProps}
            getTableBodyProps={getTableBodyProps}
            headerGroups={headerGroups}
            page={page}
            prepareRow={prepareRow}
            error={error}
          />
        </div>
      )}

      {/*!manualPagination && data && !isEmpty(data) && (
        <Pagination
          totalRows={totalDataLength}
          pageChangeHandler={setCurrentPage}
          rowsPerPage={25}
        />
      )*/}

      {!manualPagination && data && !isEmpty(data) && (
        <Row className="justify-content-md-end justify-content-center align-items-center">
          <Col className="col-md-auto">
            <div className="d-flex gap-1">
              <Button
                className="btn-sm"
                color="primary"
                onClick={previousPage}
                disabled={!canPreviousPage}
              >
                {"<"}
              </Button>
            </div>
          </Col>
          <Col className="col-md-auto d-none d-md-block">
            {t("Page")}{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
          </Col>
          <Col className="col-md-auto">
            <Input
              type="number"
              className="form-control-sm"
              min={1}
              style={{ width: 70 }}
              max={pageOptions.length}
              defaultValue={pageIndex + 1}
              onChange={onChangeInInput}
            />
          </Col>

          <Col className="col-md-auto">
            <div className="d-flex gap-1">
              <Button
                className="btn-sm" 
                color="primary" 
                onClick={nextPage} 
                disabled={!canNextPage}
              >
                {">"}
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

OrdersTableBase.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default OrdersTableBase;